module.exports = __webpack_public_path__ + "276f29ad0e14864e736de9017a184ec8.pdf";